<template>
    <transition name="modal-fade">
        <div class="modal-backdrop">
            <div class="modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
                <header class="modal-header" id="modalTitle">
                    <slot name="header"></slot>
                    <button type="button" class="btn-close" @click="close" aria-label="Close modal">&times;</button>
                </header>
                <section class="modal-body" id="modalDescription">
                    <slot name="body"></slot>
                </section>
                <footer class="modal-footer">
                    <slot name="footer">
                        I'm the default footer!
                        <button type="button" class="btn-green" @click="close" aria-label="Close modal">Close me!</button>
                    </slot>
                </footer>
            </div>
        </div>
    </transition>
</template>

<style lang="scss">
    .modal-backdrop {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 2rem;
        z-index: 2;
    }

    .modal {
        position: relative;
        width: 100%;
        max-width: 50rem;
        display: flex;
        flex-direction: column;
        padding: 2rem;
        border-radius: 5px;
        background: #fff;
        background-color: #f3f5f8;
        cursor: default;
    }

    .modal-header,
    .modal-footer {
        padding: 15px;
        display: flex;
    }

    .modal-header {
        justify-content: center;
        flex-wrap: wrap;

        .portrait {
            width: 15rem;
            height: 15rem;
            border-radius: 50%;
            margin-top: -8rem;
            background-size: cover;
            background-position: center;
        }

        .name {
            width: 100%;
            width: 100%;
            margin-top: 2rem;
            font-size: 2rem;
            font-family: 'Roboto Slab';
            font-weight: 600;
        }

        .position {
            width: 100%;
            margin-top: .5rem;
            font-size: 1.4rem;
            font-weight: 600;
            color: #666;
        }
    }

    .modal-footer {
        justify-content: center;
    }

    .modal-body {
        position: relative;
        overflow: auto;

        p {
            margin: 0;
            line-height: 1.7;
            font-size: 1.4rem;
            color: #333;
        }

        &:not(:empty) {
            padding: 20px 10px;
        }
    }

    .btn-close {
        position: absolute;
        top: 0;
        right: 0;
        border: none;
        width: 5rem;
        height: 5rem;
        font-size: 40px;
        padding: 0;
        cursor: pointer;
        font-weight: 400;
        color: #333;
        background: transparent;
        opacity: .5;
    }

    .btn-green {
        color: white;
        background: #4AAE9B;
        border: 1px solid #4AAE9B;
        border-radius: 2px;
    }

    @media (max-width: 767px) {

        .modal {
            max-height: calc(100% - 50px);
            margin-top: 50px;
        }
    }

</style>

<script>
    export default {
        name: 'modal',
        methods: {
            close() {
                this.$emit('close');
            },
        },
    };
</script>